import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../createInvoicesDataSlice";
import getCreateInvoicesDataApi from "../api/getCreateInvoicesData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.accounting.createInvoices;

  const pagedTrades = await dispatch(getCreateInvoicesDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
